export default __webpack_public_path__ + "static/media/ski_image.a2d2a127.png";